import Vue from 'vue'
import '../product-form/product-form.vue'

export default el => new Vue({
  name: 'Product Form',
  el
})